import { Listing } from '../types'

export const getParkingStorageType = (textId: string) => {
  if (textId === 'not_available') {
    return 'none'
  } else if (textId === 'free') {
    return 'included'
  } else {
    return 'paid'
  }
}

export const formatListingAddress = (listing: Listing) => {
  return `${listing.unit_number ? `${listing.unit_number} - ` : ''}${listing.building.full_street_name}`
}
